export default __webpack_public_path__ + "static/media/char_body_prem_018.b59ba324.png";